import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, X } from "lucide-react";
import logo from "@/assets/nook-logo-outline.png.asset.json";
import { openTrialDialog } from "@/components/TrialDialog";
import { track } from "@/lib/tracking";

const NAV: { to: string; label: string; hash?: boolean }[] = [
  { to: "/metodo-nook", label: "Método" },
  { to: "/#unidades", label: "Planos e unidades", hash: true },
  { to: "/trabalhe-conosco", label: "Trabalhe conosco" },
];


export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors ${
        scrolled ? "border-border bg-background/90 backdrop-blur-md" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" aria-label="Nook Gym — página inicial" className="flex items-center">
          <img src={logo.url} alt="Nook Gym" className="h-[34px] w-auto" width={134} height={34} />
        </Link>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Navegação principal">
          {NAV.map((item) =>
            item.hash ? (
              <a
                key={item.to}
                href={item.to}
                className="text-xs uppercase tracking-[0.18em] text-muted-foreground transition-colors hover:text-foreground"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                activeProps={{ className: "text-foreground" }}
                className="text-xs uppercase tracking-[0.18em] text-muted-foreground transition-colors hover:text-foreground"
              >
                {item.label}
              </Link>
            ),
          )}
          <button
            type="button"
            onClick={() => {
              track("click_experimental", { where: "header" });
              openTrialDialog("header");
            }}
            className="inline-flex h-10 items-center rounded-sm bg-nook-green px-5 text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-nook-green-foreground transition-all hover:brightness-110"
          >
            Day Use
          </button>
        </nav>

        <button
          type="button"
          className="md:hidden"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-background md:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col px-5 py-4" aria-label="Navegação mobile">
            {NAV.map((item) =>
              item.hash ? (
                <a
                  key={item.to}
                  href={item.to}
                  onClick={() => setOpen(false)}
                  className="border-b border-border py-4 text-sm uppercase tracking-[0.18em] text-foreground"
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className="border-b border-border py-4 text-sm uppercase tracking-[0.18em] text-foreground"
                >
                  {item.label}
                </Link>
              ),
            )}
          </nav>
        </div>
      )}
    </header>
  );
}

